import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/api';
import { EmailService } from 'src/app/modules/services/email.service';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {

  constructor (private fb: FormBuilder, private cookies: CookieService, @Inject(PLATFORM_ID) private platformId: Object, 
    private emailService: EmailService, private messageService: MessageService) {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      message: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(2000)]]
    });
  }

  contactForm: FormGroup
  contactNumber: string = '';
  loading: boolean = false;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.contactNumber = this.cookies.get('contact').replaceAll("\"", "");
    }
  }

  contactUs() {
    let contactUrl = 'https://api.whatsapp.com/send?phone=' + this.contactNumber;
    window.open(contactUrl);
  }

  sendMail() {
    this.loading = true;
    this.emailService.sendEmail(this.contactForm.value['name'], this.contactForm.value['email'], this.contactForm.value['subject'], this.contactForm.value['message']).subscribe({
      next: response => {
          this.messageService.add({
            severity: response.status,
            detail: response.message
        });
        this.loading = false;
      },
      error: response => {
        this.messageService.add({
          severity: response.error.status,
          detail: response.error.message
        });
        this.loading = false;
      }
    });
  }

}
